import React from 'react';
import { Card } from '@abyss/web/ui/Card';
import { IconBrand } from '@abyss/web/ui/IconBrand';
import { styled } from '@abyss/web/tools/styled';
import PropTypes from 'prop-types';

const StyledCardSection = styled(Card.Section, {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  padding: 20,
  textAlign: 'center',
});

const StyledTextTitle = styled('p', {
  fontWeight: 'bold',
  fontSize: 18,
});

const StyledTextInformation = styled('p', {
  paddingBottom: 30,
});

export const NoMatchesFound = ({ taxIdValue }) => {
  return (
    <Card header={`Search results :  ${taxIdValue}`}>
      <StyledCardSection>
        <Card.Section>
          <IconBrand icon="magnifying_glass" variant="twotone" size={60} />
          <StyledTextTitle>No matches found</StyledTextTitle>
          <StyledTextInformation>
            The information entered does not match any active emulation users.
            Please correct the <br /> information and try again or verify in
            Secure that access is still active.
          </StyledTextInformation>
        </Card.Section>
      </StyledCardSection>
    </Card>
  );
};

NoMatchesFound.propTypes = {
  taxIdValue: PropTypes.string.isRequired,
};
